import { useState, useEffect, Suspense } from "react";
import { ThemeProvider } from "@material-ui/styles";
import { darkTheme } from "./assets/theme";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./App.css";
import ScrollToTop from "./components/ScrollToTop";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./Routes";
import ThemeContext from "./contexts/themeContext";
import LoaderContext from "./contexts/loaderContext";
import AccentSwitcher from "./components/AccentSwitcher";
import { applyAccent, getStoredAccent, storeAccent } from "./assets/theme/accents";

function App() {
    // Dark-only, fully polished theme
    const [isDarkMode] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [accent, setAccent] = useState(getStoredAccent);

    useEffect(() => {
        applyAccent(accent);
        storeAccent(accent);
    }, [accent]);

    useEffect(() => {
        document.body.style.overflow = isLoading ? "hidden" : "";
        return () => {
            document.body.style.overflow = "";
        };
    }, [isLoading]);

    return (
        <Router>
            <Suspense fallback={<div></div>}>
                <ThemeContext.Provider value={{ isDarkMode }}>
                    <LoaderContext.Provider value={{ isLoading, setIsLoading }}>
                        <ThemeProvider theme={darkTheme}>
                            <CssBaseline />
                            <ScrollToTop />
                            <AccentSwitcher accent={accent} onChange={setAccent} />
                            <Routes />
                        </ThemeProvider>
                    </LoaderContext.Provider>
                </ThemeContext.Provider>
            </Suspense>
        </Router>
    );
}

export default App;
